<template>
  <vs-prompt
    color="danger"
    :title="`${!hasRestore ? subject : `Restore ${subject}`}`"
    @cancel="open = false"
    @close="open = false"
    :active.sync="open"
    buttons-hidden
  >
    <div class="text-left">
      <div v-if="hasRestore" class="font-medium">Are you sure to Restore this {{ subject }}?</div>
      <div v-else class="font-medium">Are you sure to delete this {{ subject }}?</div>
    </div>
    <div v-if="textExtra">
      <template >
        <a-alert type="error" show-icon>
          <template slot="message">
            <template v-if="subject ==='Folder'">
              This folder contains one or more files. If you delete this folder, it will delete all the files in
              this folder. This action cannot be undone.
            </template>
            <template v-if="subject ==='File'">
              This action cannot be undone.
            </template>
          </template>
        </a-alert>
      </template>
    </div>
    <div class="flex justify-center space-x-3 mt-5">
      <vs-button color="danger" type="border" @click="open = false">Cancel</vs-button>
      <vs-button color="danger" @click="removeItem">{{ textDelete }}</vs-button>
    </div>
  </vs-prompt>
</template>

<script>
import axios from "@/axios";


export default {
  name: "deleteItem",
  props:{
    url:{
      type: String
    },
    ele:{
      type: Object
    },
    subject: {
      type: String
    },
    delete_item_phone:{
      type: Boolean
    },
    hasRestore: {
      type: Boolean,
      default: false
    },
    textDelete: {
      type: String,
      default: 'Delete'
    },
    textExtra: {
      type: Boolean,
      default: false
    },
  },
  data(){
    return{
      open: false
    }
  },
  methods:{
    async removeItem(){
      try{
        this.open = false
        this.ele.loading = true
        await axios.delete(this.url)
        this.ele.query.search = undefined
        this.ele.search_tbl   = null
        await this.ele.fetch()
        this.$notification['success']({
          message: 'Success',
          description: this.hasRestore ? `${this.subject} Restored Successfully.` : `${this.subject} deleted.`
        });
      }catch (e){
        this.$notification['error']({
          message: 'Server Error',
          description:`Please try again.`
        });
      }finally {
        this.ele.loading = false
      }
    }
  },
}
</script>

<style scoped>

</style>
